import { render, staticRenderFns } from "./RosterLeavesListDeclined.vue?vue&type=template&id=28a1c354"
import script from "./RosterLeavesListDeclined.vue?vue&type=script&lang=js"
export * from "./RosterLeavesListDeclined.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports